<template>
<transition :name="transition" :enter-active-class="transEnter" :leave-active-class="transLeave">
  <div :class="[{'modal-container': true}, typeClass]" v-if="showModal">
          <div v-if="this.$slots.header" class="modal-header">
            <slot name="header"></slot>
          </div>

          <div v-if="this.$slots.body" class="modal-body">
            <slot name="body"></slot>
          </div>

          <div v-if="this.$slots.footer" class="modal-footer">
            <slot name="footer"></slot>
          </div>
  </div>
</transition>
</template>

<script>
export default {
  props: {
    transition: String,
    transEnter: String,
    transLeave: String,
    showModal: Boolean,
    typeClass: String
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  transition: opacity .3s ease;
}
*/
.modal-container {
  position: fixed;
  z-index: 2000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color:#FFF;
  transition: all .3s ease;
}

.modal-header {
  z-index: 2003;
  width: 100%;
  border: 0px
}

.modal-body {
  z-index: 2002;
  margin-top: 10px;
  display: block;
  font-size: 2em;
}

.modal-footer {
  z-index: 2001;
  border-top: 1px solid #FFF;
  display: block;
  width: 100%;
  height: 75px;
  position: absolute;
  bottom: 0px;
  text-align: right;
}

.modal-container.danger {
  background-color: #dc3545;
  color: #FFF;
}

.modal-container.menu {
  background-color: #325D88;
  color: #FFF;
  width: 70%;
}

.modal-container.dropDown {
  background-color: #29ABE0;
  color: #111;
  height: 60%;
}

.modal-container.search {
  background-color: #6610f2;
  color: #FFF;
}

.modal-container.drawer {
  bottom: 0px;
  min-height: 44%;
  background-color: #325D88;
  color: #FFF;
  top: unset;
  height: unset;
}
/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>



// WEBPACK FOOTER //
// src/components/kDialog.vue